import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
    Table,
    CardBody,
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
    Row,
    Col
} from 'reactstrap'
import { API_URL } from './utils/Constants/URLS'

const FocViewPackList = () => {
    const { sonumber, storeid } = useParams()
    const [plList, setPlList] = useState([])
    const [loading, setLoading] = useState(true)
    const [openId, setOpenId] = useState('')

    const token = localStorage.getItem('token')

    const fetchPackLists = async () => {
        setLoading(true)
        try {
            const res = await fetch(`${API_URL}foc/pick-list`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            const result = await res.json()
            const allDocs = result?.data?.docs || []

            const filtered = allDocs.filter(pl => {
                if (sonumber) {
                    const plSoNum = pl.salesOrderNumber || pl.deliveryInstruction?.salesOrderNumber || pl.deliveryInstruction?.salesOrder?.salesOrderNumber
                    return plSoNum === sonumber
                }
                if (storeid) {
                    const plStoreId = pl.store?._id || pl.store
                    return String(plStoreId) === String(storeid)
                }
                return true
            })

            setPlList(filtered)
        } catch (e) {
            console.error('Error fetching FOC PLs:', e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (sonumber || storeid) fetchPackLists()
    }, [sonumber, storeid, token])

    const toggleAccordion = id => setOpenId(prev => (prev === id ? '' : id))

    if (loading) return <p className="text-center p-3">Loading Pack Lists...</p>
    if (plList.length === 0) return <p className="text-center p-3">No Pack Lists found.</p>

    return (
        <CardBody className='p-4'>
            <h5 className='mb-4'>FOC Pack Lists</h5>
            <Accordion open={openId} toggle={toggleAccordion}>
                {plList.map((pl, idx) => {
                    const plId = pl._id || `pl-${idx}`
                    const status = pl.status || 'pending'
                    const isApproved = status === 'approved'
                    const isRejected = status === 'rejected'

                    // Extract display values matching ViewPackList format
                    const boxNumber = pl.boxNumber ?? pl.box ?? '-'
                    const salesOrderNumber = pl?.salesOrderNumber ??
                        pl?.deliveryInstruction?.salesOrderNumber ??
                        pl?.deliveryInstruction?.salesOrder?.salesOrderNumber ?? '-'
                    const diNumber = pl?.deliveryInstruction?.deliveryInstructionId ?? '-'

                    return (
                        <AccordionItem key={plId}>
                            <AccordionHeader targetId={plId}>
                                <div className='d-flex flex-column flex-md-row align-items-start gap-2 w-100'>
                                    <div style={{ minWidth: 220 }}>
                                        <strong>
                                            {salesOrderNumber} | {diNumber} |{' '}
                                            <span className='text-muted small'>
                                                Box: {boxNumber}
                                            </span>{' '}
                                            |{' '}
                                            <span
                                                className={
                                                    isApproved
                                                        ? 'text-success'
                                                        : isRejected
                                                            ? 'text-danger'
                                                            : 'text-primary'
                                                }
                                            >
                                                {status.toUpperCase()}
                                            </span>
                                        </strong>
                                    </div>
                                </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={plId}>
                                {isRejected && (
                                    <div className='alert alert-danger mb-3'>
                                        Reason: {pl.reasonForRejection}
                                    </div>
                                )}

                                <Row className='mb-3'>
                                    <Col md={4}><strong>Store:</strong> {pl.store?.name ?? pl.store}</Col>
                                    <Col md={4}><strong>Customer:</strong> {pl.customerName}</Col>
                                </Row>

                                <Table responsive striped size="sm">
                                    <thead>
                                        <tr>
                                            <th>SI</th>
                                            <th>Name</th>
                                            <th>Narration</th>
                                            <th>Part Code</th>
                                            <th>UOM</th>
                                            <th>Qty</th>
                                            <th>Value</th>
                                            <th>GST</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pl.lineItems?.map((li, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{li.model?.modelName || '-'}</td>
                                                <td>{li.narration || '-'}</td>
                                                <td>{li?.model?.partCode || '-'}</td>
                                                <td>{li?.model?.uom || '-'}</td>
                                                <td>{li.quantity}</td>
                                                <td>{li.value}</td>
                                                <td>{li.gst}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </AccordionBody>
                        </AccordionItem>
                    )
                })}
            </Accordion>
        </CardBody>
    )
}

export default FocViewPackList
